var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrow2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 46,
    viewBox: "0 0 28 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.36683 44.6528C-0.455609 42.8565 -0.455609 39.9437 1.36683 38.1474L16.7338 23.0001L1.36683 7.85272C-0.455609 6.05628 -0.455609 3.14374 1.36683 1.3473C3.18931 -0.449099 6.14407 -0.449099 7.96655 1.3473L26.6332 19.7473C28.4556 21.5438 28.4556 24.4564 26.6332 26.2527L7.96655 44.6528C6.14407 46.4491 3.18931 46.4491 1.36683 44.6528Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow2);
export default __webpack_public_path__ + "static/media/arrow2.3d9522b6fd8f2464b7200ebf2c1bb09a.svg";
export { ForwardRef as ReactComponent };